module.exports = __webpack_public_path__ + "static/img/1973_phase_function_Paper_PointsHejduk_Prediction.7b27079.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1973_phase_function_Paper_PointsHejduk_Prediction.png
// module id = viny
// module chunks = 0